export type CardType =
  | 'profile'
  | 'link'
  | 'text'
  | 'photo'
  | 'audio'
  | 'spotify_top'
  | 'spotify_current'
  | 'video'
  | 'social_icon'

export interface CardPosition {
  x: number
  y: number
  width: number
  height: number
}

export interface CardContent {
  // Profile card
  name?: string
  nickname?: string
  socialLinks?: SocialLink[]
  fontSize?: 'small' | 'medium' | 'large'
  profileAlign?: 'left' | 'center' | 'right'
  profileVAlign?: 'top' | 'center'
  theme?: 'mono' | 'glass' | 'neo' | 'wood'
  paletteSeed?: number

  // Card appearance
  paletteIndex?: 1 | 2 | 3 | 4

  // Link card
  url?: string
  label?: string
  linkAlign?: 'left' | 'right'
  linkSubpage?: string  // slug of a subpage to redirect to (instead of url)

  // Text card
  text?: string
  textFontSize?: 'small' | 'medium' | 'large'
  textAlign?: 'left' | 'center' | 'right'
  textVAlign?: 'top' | 'center'
  textTransparent?: boolean

  // Photo card
  imageUrl?: string
  imageKey?: string
  images?: string[]
  imageKeys?: string[]
  aspectRatio?: string
  photoLinkUrl?: string
  photoFilter?: 'none' | 'dither'
  photoZoomDisabled?: boolean

  // Audio card
  audioUrl?: string
  audioKey?: string
  audioTitle?: string
  audioSubtext?: string
  audioCoverUrl?: string
  subtext?: string
  cover?: string
  audioCoverKey?: string
  audioSoundcloudUrl?: string
  audioSoundcloudFetchedUrl?: string
  audioSoundcloudMetaFetched?: boolean
  audioFilter?: 'none' | 'theme'
  audioShowTextOnCard?: boolean

  // Spotify cards
  spotifyTimeRange?: 'short_term' | 'medium_term' | 'long_term'
  songCount?: number

  // Video card
  videoUrl?: string
  videoType?: 'youtube' | 'vimeo' | 'other'

  // Social icon card
  socialIconType?: SocialLink['type']
  socialIconUrl?: string
}

export interface SocialLink {
  type: 'spotify' | 'linkedin' | 'discord' | 'instagram' | 'twitter' | 'tiktok' | 'youtube' | 'github' | 'soundcloud'
  url: string
}

export interface Card {
  id: number
  card_type: CardType
  grid_x: number
  grid_y: number
  grid_width: number
  grid_height: number
  content: CardContent
  z_index: number
  page_id: number | null
}

export interface User {
  id: number
  email: string
  name: string
  profile_picture?: string
  subdomain?: string
  is_public?: boolean
  created_at?: string
}

export const CARD_MIN_SIZES: Record<CardType, { width: number; height: number }> = {
  profile: { width: 4, height: 6 },
  link: { width: 4, height: 2 },
  text: { width: 4, height: 2 },
  photo: { width: 3, height: 3 },
  audio: { width: 5, height: 2 },
  spotify_top: { width: 5, height: 6 },
  spotify_current: { width: 5, height: 4 },
  video: { width: 6, height: 4 },
  social_icon: { width: 2, height: 2 }
}

export const GRID_COLS = 17
export const GRID_ROWS = 32
